import { render, staticRenderFns } from "./dnastrand.vue?vue&type=template&id=7622d15b&"
import script from "./dnastrand.vue?vue&type=script&lang=js&"
export * from "./dnastrand.vue?vue&type=script&lang=js&"
import style0 from "./dnastrand.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports